import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ark-ui-vote-buttons',
  templateUrl: './ui-vote-buttons.component.html',
  styleUrls: ['./ui-vote-buttons.component.css'],
})
export class UiVoteButtonsComponent {
   @Input() item!: { 
    propositionId?: number | string | undefined; 
    ideaId?: number | string | undefined; 
    problemId?: number | string | undefined;
    upVoteMine?: boolean; 
    downVoteMine?: boolean; 
    upVoteCount?: number; 
    downVoteCount?: number; 
  };
  @Input() displayDownVoteCount: boolean = false;

  @Input() routeType?: 'problem' | 'idea' | 'solution' | 'thinkTank';

  @Output() upvote = new EventEmitter<number>();
  @Output() downvote = new EventEmitter<number>();

  onUpvote() {
    this.upvote.emit(Number(this.item.propositionId ?? this.item.ideaId ?? this.item.problemId));
  }

  onDownvote() {
    this.downvote.emit(Number(this.item.propositionId ?? this.item.ideaId ?? this.item.problemId));
  }
}
